
<template>
	<v-card :flat="flat">
		<v-form id="editSurveyForm" class="pa-5" ref="form">
			<v-card class="mb-2">
				<v-tabs v-model="tab" 
				show-arrows right>
					<v-tab key="editor">
						Survey Info
					</v-tab>
						<v-tab-item>
							<v-card class="pa-5">
								<v-row class="pl-3 pr-1">
									<v-text-field v-model="survey.name" label="Survey Name" ></v-text-field>
									<v-tooltip left>
										<template v-slot:activator="{ on }">
											<v-switch v-on="on" v-model="survey.active" label="Live" class="mr-4" color="success"></v-switch>
										</template>
										<span>Live surveys are accessible for completion on the internet</span>
									</v-tooltip>
								</v-row>
								<vue-editor v-model="survey.introText" label="Introduction Text" ></vue-editor>
								<v-select :items="['on','off']" v-model="survey.showQuestionNumbers" label="Show Question Numbers" class="mr-4"></v-select>
								<v-text-field v-model="survey.thankYouMessage" label="Thank you message" ></v-text-field>	
								<v-text-field prepend-icon="mdi-slash-forward" hint="The url that the user should be redirected to after the survey is submitted. This can be a relative URL on this site or another external url" persistent-hint v-model="survey.sendToAfter" label="After survey, redirect respondent to" ></v-text-field>	
								<NamedUrlField type="survey" :id="survey.id" label="Custom survey URL"></NamedUrlField>
								<v-row class="pl-3 pr-1">
									<v-switch v-on="on" v-model="survey.removeAbout" label="Remove the About Us column" class="mr-4" color="primary"></v-switch>
									<v-switch v-on="on" v-model="survey.allowRetrieveResponses" label="Allow logged in panelists to retrieve previous responses to this survey" class="mr-4" color="primary"></v-switch>
									<v-switch v-on="on" v-model="survey.urlParams" label="Prefill from URL Parameters" class="mr-4" color="primary"></v-switch>
								</v-row>
							</v-card>
						</v-tab-item>
					<v-tab key="editor">
						Editor
					</v-tab>
						<v-tab-item>
							<SurveyEditor 
							:elements="elements" 
							v-on:questionAdded="addQuestion" v-on:deleteQuestion="deleteQuestion" v-on:moveQuestion="moveQuestion" v-on:addToQuestionLibrary="addToQuestionLibrary"></SurveyEditor>
						</v-tab-item>
					<v-tab key="json">Json</v-tab>
						<v-tab-item key="json">
							<v-card class="pa-5">
								<EditSurveyJson :elements="elements" :surveyProperties="survey.surveyProperties" v-on:updated="updateFromJson"></EditSurveyJson>
							</v-card>
						</v-tab-item>				
					<v-tab key="preview">Preview</v-tab>
						<v-tab-item key="preview">
							<PreviewSurvey :survey="survey" :elements="elements"></PreviewSurvey>
						</v-tab-item>		
					<v-tab key="preview">Responses</v-tab>
						<v-tab-item key="responses">
							<SurveyResponses :survey="survey" :project="false"></SurveyResponses>
						</v-tab-item>
					<v-tab key="screener">Screener</v-tab>
						<v-tab-item key="screener">
							<v-card class="pa-5">
								<EditScreenerFields :survey="survey"></EditScreenerFields>
							</v-card>
						</v-tab-item>			
				</v-tabs>
			</v-card>
			<p class="text-right">
				<v-btn color="green" dark class="mr-4" @click="save" >Save </v-btn>
			</p>
		</v-form>
	</v-card>
</template>

<script>

import {VueEditor} from 'vue2-editor';
import SurveyEditor from "../edits/SurveyEditor";
import PreviewSurvey from "../edits/editorFields/PreviewSurvey";
import EditSurveyJson from "../edits/editorFields/EditSurveyJson";
import EditScreenerFields from "../edits/EditScreenerFields";
import SurveyResponses from "../tools/SurveyResponses";
import NamedUrlField from "../tools/NamedUrlField.vue";


export default {
	name: 'EditSurvey',
	props: {
		survey: {type: Object},
		flat: { type: Boolean, default: false }
	},
	data: () => ({
		elements: [],
	}),
	components: {
		SurveyEditor,
		PreviewSurvey,
		EditSurveyJson,
		SurveyResponses,
		EditScreenerFields,
		NamedUrlField,
		VueEditor 
	},
	methods: {
		addQuestion(question){
			this.elements.push( question )
		},
		deleteQuestion(question){
			this.elements.splice( this.elements.indexOf(question), 1 )
		},
		moveQuestion(question, direction) {
			const self = this;
			let delta = 0;
			if( direction == "up" ){
				delta = -1;
			}
			if( direction == "down" ){
				delta = 1;
			}

			var index = self.elements.indexOf(question);
			var newIndex = index + delta;
			if (newIndex < 0  || newIndex == self.elements.length) return;
			var indexes = [index, newIndex].sort((a, b) => a - b); 
			self.elements.splice(indexes[0], 2, self.elements[indexes[1]], self.elements[indexes[0]]); 
		},
		addToQuestionLibrary(question){
			const self = this;
			self.$store.dispatch("addDoc", {
				collection: "surveyQuestionLibrary",
				data: question
			}).then( (ref) => { 
				self.$store.dispatch("bindAnything", {id: ref.id, collection: "surveyQuestionLibrary", then: "SET_ANYTHING", reference: "surveyQuestionLibrary"} )
				self.message = "Question saved";
				self.clicked = true;
			})
		},
		save() {
			var self = this;
			let update = {};
			for( var key in self.survey ){
				if( typeof self.survey[key] !== 'undefined'){
					update[key] = self.survey[key];	
				} 
			}
			update.elements = self.elements;
			if( !update.elements ){
				update.elements = [];
			}
			self.$store.dispatch("updateDoc", {
				doc: "surveys/" + self.survey.id,
				data: update,
				action: "update"
			}).then( function(){
				self.$emit("saved");
			}) 
		},
		updateFromJson({elements, surveyProperties}){
			this.elements = Object.values(elements);
			for( var key in surveyProperties ){

				if( key == 'elements' ){ return; }
				if( typeof this.survey[key] != 'undefined' ){
					this.survey[key] = surveyProperties[key];
				}
				this.survey.surveyProperties[key] = surveyProperties[key];
				
			}
		},

	},
	watch:{
		survey(survey){			
			if( survey ){
				this.elements = survey.elements
			}
		}
	},
	created(){
		const self = this;	
		if( self.survey ){
			this.elements = self.survey.elements
			if( !this.elements ){
				this.elements = [];
			}
		}
		if( !self.survey.showQuestionNumbers ){
			self.survey.showQuestionNumbers = "off";
		}
		if( !self.survey.surveyProperties ){
			self.survey.surveyProperties = {}
		}
	}
};

</script>
